import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import type { Account } from "../../api";
import { Field, Notice, Select } from "../../components/ui";
import { BankStatements } from "./BankStatements";
import { Moves } from "./Moves";

/**
 * Aba "Conciliação" de Contas e Extratos (F2-E5 / M5). Duas visões sobre a mesma conta:
 *  - Movimentações: conciliação MANUAL (DEC-095), sem extrato, CSV ou linha;
 *  - Extratos bancários: períodos, linhas do banco, conciliação ASSISTIDA, diferença banco × MM MONEY, concluir e reabrir.
 * A tela só chama as APIs homologadas (M4) e exibe o que o servidor devolve: nenhuma regra de conciliação ou cálculo financeiro é feito aqui.
 */
export function ConciliationTab({ realm, accounts, canWrite }: { realm: string; accounts: Account[]; canWrite: boolean }) {
  const [sp, setSp] = useSearchParams();
  const view = sp.get("visao") === "extratos" ? "extratos" : "movimentacoes";
  const [accountId, setAccountId] = useState("");
  useEffect(() => { setAccountId((cur) => (cur && accounts.some((a) => a.id === cur) ? cur : (accounts.find((a) => a.status === "ativa") ?? accounts[0])?.id ?? "")); }, [accounts]);
  const account = accounts.find((a) => a.id === accountId);
  const setView = (v: "movimentacoes" | "extratos") => setSp((p) => { const n = new URLSearchParams(p); n.set("aba", "conciliacao"); n.set("visao", v); n.delete("extrato"); return n; }, { replace: true });
  if (!account) return <div className="card stub"><h3>Nenhuma conta cadastrada</h3><p className="muted" style={{ margin: 0 }}>Cadastre uma conta em Contas Financeiras para conciliar.</p></div>;
  return (
    <>
      {!canWrite && <Notice>Você tem acesso somente de consulta a esta empresa: é possível ver extratos e conciliações, mas não alterá-los.</Notice>}
      <div className="toolbar filters">
        <Field label="Conta"><Select value={accountId} onChange={(e) => { setAccountId(e.target.value); setSp((p) => { const n = new URLSearchParams(p); n.delete("extrato"); return n; }, { replace: true }); }} name="reconAccount">{accounts.map((a) => <option key={a.id} value={a.id}>{a.name} ({a.currency}){a.status === "inativa" ? " — inativa" : ""}</option>)}</Select></Field>
        <div className="seg" role="tablist" aria-label="Visão da conciliação">
          <button role="tab" aria-selected={view === "movimentacoes"} aria-pressed={view === "movimentacoes"} data-view="movimentacoes" onClick={() => setView("movimentacoes")}>Movimentações</button>
          <button role="tab" aria-selected={view === "extratos"} aria-pressed={view === "extratos"} data-view="extratos" onClick={() => setView("extratos")}>Extratos bancários</button>
        </div>
      </div>
      {view === "movimentacoes" ? <Moves key={account.id} realm={realm} account={account} canWrite={canWrite} /> : <BankStatements key={account.id} realm={realm} account={account} canWrite={canWrite} />}
    </>
  );
}
